import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer'
import PageReducer from './PageReducer'
import CarritoReducer from './CarritoReducer'
import MsalReducer from './MsalReducer';
import CarritoPromoReducer from './CarritoPromoReducer';
import CategorieReducer from './CategorieReducer';

export default combineReducers({
    auth: AuthReducer,
    page: PageReducer,
    carrito: CarritoReducer,
    carritoPromo: CarritoPromoReducer,
    msal: MsalReducer,
    categories: CategorieReducer
});